import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords don't match."); return; }
    if (!token) { toast.error("No reset token in URL."); return; }
    setBusy(true);
    try {
      await api.post("/collector-auth/password-reset/confirm", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed.");
    } finally { setBusy(false); }
  };

  if (done) return (
    <div className="container-gm py-16 max-w-md">
      <SEO title="Password reset complete" />
      <div className="rounded-3xl border-2 border-[var(--ink)] bg-white p-8" data-testid="reset-success">
        <div className="kicker kicker-yellow">Password updated</div>
        <h1 className="h-display text-3xl mt-3">You&apos;re all set</h1>
        <p className="mt-4 text-[var(--smoke)]">Sign in with your new password.</p>
        <button onClick={() => navigate("/login")} className="btn-red text-sm mt-6" data-testid="reset-goto-login">Go to sign in</button>
      </div>
    </div>
  );

  return (
    <div className="container-gm py-16 max-w-md">
      <SEO title="Reset password" />
      <div className="kicker kicker-red">Collector Registry</div>
      <h1 className="h-display text-4xl mt-3">Choose a new password</h1>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
        <label className="block">
          <div className="kicker kicker-black text-[11px] mb-1">New password (min 10 chars, letters + numbers)</div>
          <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" className="gm-field" />
        </label>
        <label className="block">
          <div className="kicker kicker-black text-[11px] mb-1">Confirm new password</div>
          <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password2" className="gm-field" />
        </label>
        <button type="submit" disabled={busy} data-testid="reset-submit" className="btn-red text-sm w-full disabled:opacity-60">
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
